<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>

<form [formGroup]="ticketForm" class="ticket-holder">
  <div class="col-md-12 p-0 m-0">
    <table class="table p-0 m-0">
      <tr *ngIf="responseHistory">
        <td>
          <span style="color: #ff6d1c">TicketID</span>:<br>
          <span>{{responseHistory['ticket']}}</span>
        </td>
        <td>
          <span style="color: #ff6d1c">Status</span><br>
          <span>{{responseHistory['ticketStatus']}}</span>

        </td>
        <td>
          <span style="color: #ff6d1c"> Opened on</span>
          <br>
          <span>{{responseHistory['ticketCreatedDate']}}</span>
        </td>
        <td>
          <span style="color: #ff6d1c">Assigned to</span>
          <br>
          <span>{{responseHistory['ticketOwner']}}</span>
        </td>
        <td>
          <span style="color: #ff6d1c">No of days</span>
          <br>
          <span>{{responseHistory['HistoryLastUpdated']}}</span>
        </td>
      </tr>
    </table>
  </div>
  <div class="col-md-12">
    <p *ngIf="responseHistory && responseHistory['GenderID']===1">Mail going to Bride===>
      {{responseHistory['toname']}},{{responseHistory['toProfileID']}}({{responseHistory['toEmail']}})</p>
      <p *ngIf="responseHistory && responseHistory['GenderID']===2">Mail going to Groom===>
        {{responseHistory['toname']}},{{responseHistory['toProfileID']}}({{responseHistory['toEmail']}})</p>
  </div>
  <div class="button-container-holder">
    <button class="btn btn-primary btn-outline " *ngIf="type==='communication'"
      [ngClass]="isDataIncoming==='view' ? 'active' : ''" (click)="changeTab(0)">View</button>
    <button class="btn btn-primary btn-outline " [ngClass]="isDataIncoming==='Incoming' ? 'active' : ''"
      (click)="changeTab(1)" [disabled]="(isDisableTabs || noAccess)" >Incoming Call</button>
    <button class="btn btn-primary btn-outline" [ngClass]="isDataIncoming==='outGoing' ? 'active' : ''"
      (click)="changeTab(2)" [disabled]="(isDisableTabs || noAccess)" >Outgoing Call</button>
  </div>
  <div class="row ka-em-view-tkt" *ngIf="isDataIncoming==='view'" style="margin-left: 6px;">
    <div class="col-md-1">Mobile:</div>
      <span class="col-md-3" *ngIf="data.history.FromOwnerID == loginData?.employeeID || loginData?.isManagement == 1 else notRmORManagement">
       {{data?.phoneNumber}}
      </span>
      <ng-template #notRmORManagement>
        <span class="col-md-3" style="color: red;cursor: pointer;" 
      (click)="noAccess == true ? noAccessPopup() : makingCall('NA', 'Mobile', data?.phoneNumber, data.history.FromCustID, data.history.FromOwnerID, data)">
       View Contact
      </span>
      </ng-template>
    <div class="col-md-1" style="margin-left: 2%">Email:</div>
      <span class="col-md-4" *ngIf="data.history.FromOwnerID == loginData?.employeeID || loginData?.isManagement == 1 else notRmEmail">
       {{data?.email}}
      </span>
     <ng-template #notRmEmail>
       <span class="col-md-3" style="color: red;cursor: pointer;" 
      (click)="noAccess == true ? noAccessPopup() : makingCall('NA', 'Email', data?.email, data.history.FromCustID, data.history.FromOwnerID, data)">
      View Email
     </span>
     </ng-template>
    <div class="col-md-2" style="color: #337ab7;cursor: pointer;" *ngIf="isDisableTabs" (click)="openMatchFollowTicket(data.ticketId)">Open Ticket</div>
  </div>

  <div *ngIf="isDataIncoming==='view'">
    <div *ngFor="let eachTicket of ticketHistory"  style="text-align: center;">
      <div class="ka-em-hstr-label" *ngIf="eachTicket['TicketType']==='INTERNAL MEMO'">
        <span style="padding-left: 1%;">{{eachTicket['TicketInfo']}}</span>
      </div>
      <div class="row ka-tkt-emp-name" *ngIf="eachTicket['TicketType']==='INTERNAL MEMO' || eachTicket['TicketType']==='CLOSE'">
        <div class="col" >
          <span>Employee Name</span>
        </div>
        <div class="col">
          <span>{{eachTicket['EmployeeName']}}</span>
        </div>
        <div class="col"></div>
      </div>
      <div class="row ka-tkt-emp-name comments" *ngIf="eachTicket['TicketType']==='INTERNAL MEMO'|| eachTicket['TicketType']==='CLOSE'">
        <div class="col">
          <span>Comments</span>
        </div>
        <div class="col">
          <span>{{eachTicket['Body']}}</span>
        </div>
        <div class="col"></div>

      </div>
  <br>
  
      <div class="ka-em-hstr-label" *ngIf="eachTicket['TicketType']==='MatchFollowupReply'">
        <span style="padding-left: 1%;">{{eachTicket['TicketInfo']}}</span>
      </div>
      <div class="row ka-tkt-emp-name" *ngIf="eachTicket['TicketType']==='MatchFollowupReply'">
        <div class="col">
          <span>Customer Name</span>
        </div>
        <div class="col">
          <span>{{responseHistory['FromName']}}</span>
        </div>
        <div class="col"></div>

      </div>
      <div class="row ka-tkt-emp-name comments" *ngIf="eachTicket['TicketType']==='MatchFollowupReply' && responseHistory['FromName']">
        <div class="col">
          <span>Comments</span>
        </div>
        <div class="col">
          <span>{{eachTicket['Body']}}</span>
        </div>
        <div class="col"></div>

      </div>
  
  
      <div class="ka-em-hstr-label" *ngIf="eachTicket['TicketType']==='OUT GOING' || eachTicket['TicketType']==='INCOMING'">
        <span style="padding-left: 1%;">{{eachTicket['TicketInfo']}}</span>
      </div>
      <div class="row ka-tkt-emp-name" *ngIf="eachTicket['TicketType']==='OUT GOING' || eachTicket['TicketType']==='INCOMING'">
        <div class="col">
          <span>Call Done By</span>
        </div>
        <div class="col">
          <span>{{eachTicket['EmployeeName']}}</span>
        </div>
        <div class="col"></div>

      </div>
  
      <div class="row ka-tkt-emp-name" *ngIf="eachTicket['TicketType']==='OUT GOING' || eachTicket['TicketType']==='INCOMING'">
        <div class="col">
          <span>Call Status</span>
        </div>
        <div class="col">
          <span>{{eachTicket['CallResult']}}</span>
        </div>
        <div class="col"></div>

      </div>
  
      <div class="row ka-tkt-emp-name" *ngIf="eachTicket['TicketType']==='OUT GOING' || eachTicket['TicketType']==='INCOMING'">
        <div class="col">
          <span>Call Received From</span>
        </div>
        <div class="col">
          <span>{{eachTicket['RelationName']}}</span> <span>({{eachTicket['Relation']}})</span>
        </div>
        <div class="col"></div>

      </div>
      <div class="row ka-tkt-emp-name" *ngIf="eachTicket['TicketType']==='OUT GOING' || eachTicket['TicketType']==='INCOMING' && responseHistory['FromName']">
        <div class="col">
          <span>Call Discussion</span>
        </div>
        <div class="col">
          <span>{{eachTicket['Body']}}</span>
        </div>
        <div class="col"></div>
      </div>
      <div class="row ka-tkt-emp-name comments">
        <div class="col">
          <span>Match Follow-up Reason</span>
        </div>
        <div class="col">
          <span *ngIf="eachTicket['MatchFollowUp_Reason'] !== null && eachTicket['MatchFollowUp_Reason'] !== ''; else noFollowUpReason">{{eachTicket['MatchFollowUp_Reason']}}</span>
          <ng-template #noFollowUpReason>---</ng-template>
        </div>
        <div class="col"></div>

      </div>
  
      <div class="ka-em-boder-line"></div>
  
    </div>
  </div>
 


  <div class="col-md-12 row" *ngIf="isDataIncoming==='Incoming'">


    <div class="col-md-2">Call received from<span class="ka-em-requried">*</span></div>
    <div class="col-md-2">
      <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings" [data]="relationArray"
        formControlName="callRecv" (ngModelChange)="selectedRelation($event)">
      </ng-multiselect-dropdown>
      <div *ngIf="ticketForm['value']['callRecv']==='' || ticketForm['value']['callRecv']===null || ticketForm['value']['callRecv'] === undefined && isTicketSubmitted === true" class="error-msg1">
        Call received is required.
      </div>
    </div>
    <!-- {{data.fromProfileid}} -->
    <div class="col-md-2">Relation name<span class="ka-em-requried">*</span></div>

    <div class="col-md-2"><input type="text" formControlName="relationName" class="form-control">
      <div *ngIf="ticketForm['value']['relationName']==='' || ticketForm['value']['relationName']===null || ticketForm['value']['relationName']===undefined && isTicketSubmitted === true" class="error-msg1">
        Relation is required.
      </div>
    </div>
    <div class="col-md-2">Call telephone number</div>
    <div class="col-md-2">
      <input type="text" formControlName="telNo" class="form-control">
      <!-- <div *ngIf="ticketForm['value']['telNo']==='' && isTicketSubmitted === true" class="error-msg1">
        Call telephone number is required.
      </div> -->
    </div>
    <div class="col-md-2"> Call result<span class="ka-em-requried">*</span></div>

    <div class="col-md-10 radio-container row" style="padding: 10px;">
      <div>
        <input type="radio" formControlName="callResult" (click)="callResult(1)" id="Successfull1"
          value="417">
          <label for="Successfull1" style="font-weight: bold !important;">Successfull</label>
      </div>
      <div>
        <input type="radio" formControlName="callResult" id="UnSuccessfull1" (click)="callResult(0)"
          value="418">
          <label for="UnSuccessfull1" style="font-weight: bold !important;">UnSuccessfull</label>
      </div>
      <div>
        <input type="radio" formControlName="callResult" id="DidNotCall1" (click)="callResult(2)" value="587">
        <label for="DidNotCall1" style="font-weight: bold !important;">Did Not Call</label>
      </div>
      <div style="padding-top: 0%;padding-left: 15px;" *ngIf="ticketForm['value']['callResult']==='' || ticketForm['value']['callResult']===null || ticketForm['value']['callResult']===undefined && isTicketSubmitted === true" class="error-msg1">
        Call Result is required.
      </div>
    </div>
  
    <div class="col-md-2">Voice call Type<span class="ka-em-requried">*</span></div>
    <div class="col-md-2">
      <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings" [data]="voiceCallsType"
        formControlName="voiceCallType">
      </ng-multiselect-dropdown>
      <div *ngIf="ticketForm['value']['voiceCallType']==='' || ticketForm['value']['voiceCallType']===null || ticketForm['value']['voiceCallType']===undefined && isTicketSubmitted === true" class="error-msg1">
        Voice Call Type is required.
      </div>
    </div>
    <div class="col-md-2" style="text-align: left;">Reply Type<span class="ka-em-requried" >*</span></div>
    <div class="col-md-6 radio-container row" style="margin-left: -82px;top: 4px;">
      <div  *ngIf="isDisplayInterested === true">
        <input type="radio" formControlName="rType" id="Interested" (click)="replyType(1)" value="1" >
        <label for="Interested" style="font-weight: bold !important;">Interested</label>
      </div>
      <div  *ngIf="isDisplayInterested === true">
        <input type="radio" formControlName="rType" id="notInterested" (click)="replyType(2)" value="2">
        <label for="notInterested" style="font-weight: bold !important;">Not Interested</label>
      </div>
      <div>
        <input type="radio" formControlName="rType" id="pending" (click)="replyType(3)" (input)="isReasonFlag($event)" value="3">
        <label for="pending" style="font-weight: bold !important;">Pending</label>
      </div>
      <div>
        <input type="radio" formControlName="rType" id="followUp" (input)="isReasonFlag($event)" (click)="replyType(4)" value="4">
        <label for="followUp" style="font-weight: bold !important;">FollowUpTicket</label>
      </div>
      <div *ngIf="ticketForm['value']['rType']==='' || ticketForm['value']['rType']===null || ticketForm['value']['rType']===undefined && isTicketSubmitted === true" class="error-msg1" 
      style="left: 95%; bottom: 20px;">Reply Type is required.
      </div>
    </div>
    <div class="col-md-12 m-0 p-0 row" *ngIf="isCallDiscussion">
      <div class="col-md-2">Call Discussion<span class="ka-em-requried">*</span></div>
      <div class="col-md-10">
        <textarea name="" id="" cols="30" rows="2" class="form-control" formControlName="callDiscussion" placeholder="Office Purpose Only" [ngClass]="isCallDiscussionDisabled ? 'disabled' : ''"></textarea>
        <div *ngIf="ticketForm['value']['callDiscussion']===''|| ticketForm['value']['callDiscussion']===null || ticketForm['value']['callDiscussion']===undefined && isTicketSubmitted === true" class="error-msg1">
          Office Purpose Only is required.
        </div>
      </div>
    </div>
    <div class="col-md-12 m-0 p-0 row" *ngIf="isCallDescription">
      <div class="col-md-2">Call Description<span class="ka-em-requried">*</span></div>
      <div class="col-md-10">
        <textarea name="" id="" cols="30" rows="2" class="form-control" formControlName="notes" id="notes1"></textarea>
        <div *ngIf="ticketForm['value']['notes']==='' || ticketForm['value']['notes']===null || ticketForm['value']['notes']===undefined && isTicketSubmitted === true" class="error-msg1">
          Call Description is required.
        </div>
      </div>
    </div>
    <!-- <div class="col-md-12 m-0 p-0 row" *ngIf="isDisplayToCustomer">
      <div class="col-md-2">Display To Customer</div>
      <div class="col-md-10 radio-container row">
        <div>
          <input type="radio" formControlName="displayToCustomer" id="yes" value=1 (click)="displayToCustomer(1)">Yes
        </div>
        <div>
          <input type="radio" formControlName="displayToCustomer" id="No" value=0 (click)="displayToCustomer(2)">No
        </div>
      </div>
    </div> -->
    <div class="col-md-12 m-0 p-0 row" *ngIf="isReason">
      <div class="col-md-2">Reason<span class="ka-em-requried">*</span></div>
      <div class="col-md-6">
        <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="reasonDropdownSettings" [data]="TicketReasonArray"
          formControlName="reason">
        </ng-multiselect-dropdown>
        <div class="error-msg1" *ngIf="ticketForm['value']['reason'] === '' || ticketForm['value']['reason'] === null">
          Reason Is Required
        </div>
      </div>
    </div>
    <div class="col-md-12 button-container">
      <button class="btn btn-primary" (click)="submitIncoming()" >
        {{getType()}}</button>

    </div>

  </div>

  <div class="col-md-12 row" *ngIf="isDataIncoming==='outGoing'">
    <div class="col-md-2">Call received By<span class="ka-em-requried">*</span></div>
    <div class="col-md-2">
      <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings" [data]="relationArray"
        formControlName="callRecv" (ngModelChange)="selectedRelation($event)">
      </ng-multiselect-dropdown>
      <div *ngIf="ticketForm['value']['callRecv']===''|| ticketForm['value']['callRecv']===null || ticketForm['value']['callRecv']===undefined && isTicketSubmitted === true" class="error-msg1">
        Call received is required.
      </div>
    </div>
    <!-- {{data.fromProfileid}} -->
    <div class="col-md-2">Relation name<span class="ka-em-requried">*</span></div>

    <div class="col-md-2"><input type="text" formControlName="relationName" class="form-control">
      <div *ngIf="ticketForm['value']['relationName']==='' || ticketForm['value']['relationName']===null || ticketForm['value']['relationName']===undefined && isTicketSubmitted === true" class="error-msg1">
        Relation is required.
      </div>
    </div>
    <div class="col-4"></div>
    <!-- <div class="col-md-2">Call telephone number</div> -->
    <!-- <div class="col-md-2"> -->
      <!-- <input type="text" formControlName="telNo" class="form-control"> -->
      <!-- <div *ngIf="ticketForm['value']['telNo']==='' && isTicketSubmitted === true" class="error-msg1">
        Call telephone number is required.
      </div> -->
    <!-- </div> -->
    <div class="col-md-2"> Call result<span class="ka-em-requried">*</span>
    </div>

    <div class="col-md-10 radio-container row" style="padding: 10px;">
      <div>
        <input type="radio" formControlName="callResult" (click)="callResult(1)" id="Successfull"
          value="417">
          <label for="Successfull" style="font-weight: bold !important;">Successfull</label>
          
      </div>
      <div>
        <input type="radio" formControlName="callResult" id="notInterested1" (click)="callResult(0)"
          value="418">
          <label for="notInterested1" style="font-weight: bold !important;">UnSuccessfull</label>
      </div>
      <div>
        <input type="radio" formControlName="callResult" id="DidNotCall" (click)="callResult(2)" value="587">
        <label for="DidNotCall" style="font-weight: bold !important;">Did Not Call</label>
      </div>
      <div *ngIf="ticketForm['value']['callResult']===''|| ticketForm['value']['callResult']===null || ticketForm['value']['callResult']===undefined && isTicketSubmitted === true" class="error-msg1" 
      style="padding-top: 0%;padding-left: 15px;">
        Call result is required.
      </div>
    </div>
    
    <div class="col-md-2">Voice call Type<span class="ka-em-requried">*</span></div>
    <div class="col-md-2">
      <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings" [data]="voiceCallsType"
        formControlName="voiceCallType">
      </ng-multiselect-dropdown>
      <div *ngIf="ticketForm['value']['voiceCallType']==='' || ticketForm['value']['voiceCallType']===null || ticketForm['value']['voiceCallType']===undefined&& isTicketSubmitted === true" class="error-msg1">
        Voice Call Type is required.
      </div>
    </div>
    <div class="col-md-2" style="text-align: left">Reply Type<span class="ka-em-requried" >*</span></div>
    <div class="col-md-6 radio-container row" style="margin-left: -82px;top: 4px;">
      <div *ngIf="isDisplayInterested === false"></div>
      <div *ngIf="isDisplayInterested === true">
        <input type="radio" formControlName="rType" id="Interested1" (click)="replyType(1)" value="1" >
        <label for="Interested1" style="font-weight: bold !important;">Interested</label>
      </div>
      
      <div *ngIf="isDisplayInterested === true">
        <input type="radio" formControlName="rType" id="NotInterested1" (click)="replyType(2)" value="2" >
        <label for="NotInterested1" style="font-weight: bold !important;">Not Interested</label>
      </div>
      <div *ngIf="isDisplayInterested === true"></div>
      <div>
        <input type="radio" formControlName="rType" id="Pending1" (click)="replyType(3)" (input)="isReasonFlag($event)" value="3">
        <label for="Pending1" style="font-weight: bold !important;">Pending</label>
      </div>
      <div>
        <input type="radio" formControlName="rType" id="FollowUpTicket1" (input)="isReasonFlag($event)" (click)="replyType(4)" value="4">
        <label for="FollowUpTicket1" style="font-weight: bold !important;">FollowUpTicket</label>
      </div>
      <div *ngIf="ticketForm['value']['rType']==='' || ticketForm['value']['rType']===null || ticketForm['value']['rType']===undefined && isTicketSubmitted === true" class="error-msg1" 
      style="left: 95%; bottom: 20px;">
        Reply Type is required.
      </div>
    </div>
    <div class="col-md-12 m-0 p-0 row" *ngIf="isCallDiscussion">
      <div class="col-md-2">Call Discussion<span class="ka-em-requried">*</span></div>
      <div class="col-md-10">
        <textarea name="" id="" cols="30" rows="2" class="form-control" formControlName="callDiscussion" placeholder="Office Purpose Only" [ngClass]="isCallDiscussionDisabled ? 'disabled' : ''"></textarea>
        <div *ngIf="ticketForm['value']['callDiscussion']==='' || ticketForm['value']['callDiscussion']===null || ticketForm['value']['callDiscussion']===undefined && isTicketSubmitted === true" class="error-msg1">
          Office Purpose Only is required.
        </div>
      </div>
    </div>
    <div class="col-md-12 m-0 p-0 row" *ngIf="isCallDescription">
      <div class="col-md-2">Call Description<span class="ka-em-requried">*</span></div>
      <div class="col-md-10">
        <textarea name="" id="" cols="30" rows="2" class="form-control" formControlName="notes"></textarea>
        <div *ngIf="ticketForm['value']['notes']==='' || ticketForm['value']['notes']===null || ticketForm['value']['notes']===undefined && isTicketSubmitted === true" class="error-msg1">
          Call Description is required.
        </div>
    
      </div>

    </div>
    <!-- <div class="col-md-12 m-0 p-0 row" *ngIf="isDisplayToCustomer">
    <div class="col-md-2">Display To Customer<span class="ka-em-requried">*</span></div>
    <div class="col-md-10 radio-container row">
      <div>
        <input type="radio" formControlName="displayToCustomer" id="yes-1" value=1 (click)="displayToCustomer(1)">Yes
      </div>
      <div>
        <input type="radio" formControlName="displayToCustomer" id="No-2" value=0 (click)="displayToCustomer(2)">No
      </div>
    </div>
  </div> -->
  <div class="col-md-12 m-0 p-0 row" *ngIf="isReason">
    <div class="col-md-2">Reason<span class="ka-em-requried">*</span></div>
    <div class="col-md-6">
      <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="reasonDropdownSettings" [data]="TicketReasonArray"
        formControlName="reason">
      </ng-multiselect-dropdown>
      <div class="error-msg1" *ngIf="ticketForm['value']['reason'] === '' || ticketForm['value']['reason'] === null">
        Reason Is Required
      </div>
    </div>
  </div>
    <div class="col-md-12 button-container">
      <button class="btn btn-primary" (click)="submitIncoming()">{{getType()}}</button>

    </div>

  </div>


</form>

<div mdbModal #alertModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">

    <div class="modal-content">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="alertModal.hide()">
        <span aria-hidden="true" class="">&times;</span>
      </button>
      <div class="row text-left">

        <!--Grid column-->
        <div class="col-md-12 rmSectionPopup">
          <div class="row p-2 m-2">

            <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
              <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
              <p class="mt-2 p-0">{{alertMessage}} </p>

              <div class="action-buttons">
                <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2" mdbWavesEffect
                  type="submit" (click)="alertModal.hide()">close
                </button>



              </div>

            </div>
          </div>

        </div>

        <!--Grid column-->
      </div>
    </div>
  </div>
</div>

<div mdbModal #successModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="myBasicModalLabel" aria-hidden="true"
  [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">

    <div class="modal-content">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="successModal.hide()">
        <span aria-hidden="true" class="">&times;</span>
      </button>
      <div class="row text-left">
        <div class="col-md-12 rmSectionPopup">
          <div class="row p-2 m-2">

            <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
              <p class="mt-2 p-0">{{responseMessage}} </p>

              <div class="action-buttons">
                <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2" mdbWavesEffect
                  type="submit" (click)="successModal.hide()">ok
                </button>



              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>


<div mdbModal #reasonModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
    aria-hidden="true" [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">

        <div class="modal-content" *ngIf="!showMobileOrEmail">
            <b style="text-align: center;margin: 10px;">Please provide the reason to view Contact details</b>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeReasonDialog()">
                <span aria-hidden="true" class="">&times;</span>
            </button>
            <form class="row text-left" [formGroup]="reasonForm" (ngSubmit)="reasonToView($event)">
                <div class="col-md-12 rmSectionPopup">
                    <div class="row p-2 m-2">

                        <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                            <div class="row mb-3" style="justify-content: center; display: flex;" >

          
                              <select id="name" class="form-select ka-dropdown-singleSelect col-7" style="width: 400px" formControlName="reason" aria-label="Default select example">
                                  <option  class="select-option" [ngValue]="null" disabled selected hidden>Select reason to view contact</option>
                                  <option class="select-option" *ngFor="let reason of callReasonArray" [ngValue]="reason">{{reason.value}}</option>   
                              </select>
                  
                  
                          </div>

                            <div style="display: flex; justify-content: center; cursor: pointer;">
                                <button class="btn btn-primary" type="submit" [disabled]="reasonForm.invalid">Submit</button>
                                <p style="cursor: pointer;" (click)="closeReasonDialog()" style="padding-top: 3%;
                                 padding-left: 2%;"> <span>Cancel</span></p>
                            </div>


                        </div>
                    </div>

                </div>
            </form>
        </div>
        <div class="modal-content" *ngIf="showMobileOrEmail">
            <b style="text-align: center;margin: 10px;">Contact Details</b>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeReasonDialog()">
                <span aria-hidden="true" class="">&times;</span>
            </button>
            <form class="row text-left" [formGroup]="reasonForm" (ngSubmit)="reasonToView($event)">
                <div class="col-md-12 rmSectionPopup">
                    <div class="row p-2 m-2">

                        <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                            {{responseMessage}}

                            <div style="display: flex; justify-content: center; cursor: pointer;">
                                <p style="cursor: pointer;" (click)="closeReasonDialog()" style="padding-top: 3%;
                                 padding-left: 2%;"> <span>Cancel</span></p>
                            </div>


                        </div>
                    </div>

                </div>
            </form>
        </div>

         
   </div>
</div>